import { render } from "./NavIndicator.vue?vue&type=template&id=556eed96&scoped=true"
import script from "./NavIndicator.vue?vue&type=script&lang=js"
export * from "./NavIndicator.vue?vue&type=script&lang=js"

import "./NavIndicator.vue?vue&type=style&index=0&id=556eed96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556eed96"]])

export default __exports__